import { useCallback } from 'react';
import { useSurveyContext } from '../context/useSurveryContext';
import useSurveysReceive from './useSurveysReceive';

export const useSurveyFlow = () => {
	const {
		selectedOption,
		setSelectedOption,
		response,
		setResponse,
		otherResponse,
		setOtherResponse,
		setCompleted,
		currentQuestion,
		setCurrentQuestion,
		survey,
	} = useSurveyContext();

	const { saveSurvey } = useSurveysReceive();

	//const { OBLIATORIO, TIPO_DE_RESPUESTA } = currentQuestion;

	const isDisabled = Boolean(
		currentQuestion?.OBLIGATORIO === 'X' &&
			((['001', '004', '006'].includes(currentQuestion.TIPO_DE_RESPUESTA) &&
				response.trim() === '') ||
				(['002', '003'].includes(currentQuestion.TIPO_DE_RESPUESTA) &&
					(!selectedOption ||
						(selectedOption?.TEXTO_ABIERTO && otherResponse.trim() === ''))))
	);

	const handleContinue = useCallback(async () => {
		if (currentQuestion?.OBLIGATORIO === 'X') {
			if (
				['001', '004', '006'].includes(currentQuestion.TIPO_DE_RESPUESTA) &&
				response.trim() === ''
			)
				return;
			if (
				['002', '003'].includes(currentQuestion.TIPO_DE_RESPUESTA) &&
				!selectedOption
			)
				return;
			if (
				['002', '003'].includes(currentQuestion.TIPO_DE_RESPUESTA) &&
				selectedOption?.TEXTO_ABIERTO &&
				otherResponse.trim() === ''
			)
				return;
		}

		// Determinar el valor de respuesta a enviar
		let answerValue: string | number | undefined;
		if (['001', '004', '006'].includes(currentQuestion!.TIPO_DE_RESPUESTA)) {
			answerValue = response;
		} else if (['002', '003'].includes(currentQuestion!.TIPO_DE_RESPUESTA)) {
			answerValue = selectedOption?.TEXTO_ABIERTO
				? `${selectedOption.ID_RESPUESTA}-${otherResponse.trim()}`
				: selectedOption?.ID_RESPUESTA;
		}

		if (currentQuestion?.TIPO_DE_RESPUESTA === '005') {
			answerValue = 'X';
		}

		const payload = {
			ID_PREGUNTA: currentQuestion!.ID_PREGUNTA,
			OPCION: '1',
			VALOR_RESPUESTA: answerValue,
		};

		// Validamos el guardado de la encuesta
		const isSaved = await saveSurvey(payload);
		if (!isSaved) {
			//console.error('Error al guardar la encuesta');
			return;
		}

		// Determinar la siguiente pregunta
		let nextId: string | undefined;
		if (
			currentQuestion?.TIPO_DE_RESPUESTA === '001' ||
			currentQuestion?.TIPO_DE_RESPUESTA === '004' ||
			currentQuestion?.TIPO_DE_RESPUESTA === '005' ||
			currentQuestion?.TIPO_DE_RESPUESTA === '006'
		) {
			// Para texto abierto usamos la primera opción definida
			nextId =
				currentQuestion.OPCIONES &&
				currentQuestion.OPCIONES[0].PREGUNTA_SIGUIENTE;
		} else {
			nextId = selectedOption?.PREGUNTA_SIGUIENTE;
		}

		if (nextId && survey) {
			const nextQuestion = survey.PREGUNTAS.find((p) => p.ID_PREGUNTA === nextId);
			if (nextQuestion) {
				setCurrentQuestion(nextQuestion);
				// Reiniciamos los estados para la nueva pregunta
				setSelectedOption(null);
				setResponse('');
				setOtherResponse('');
				return;
			}
		}
		// Si no se encuentra la siguiente pregunta, se marca la encuesta como completada
		setCompleted(true);
	}, [
		currentQuestion,
		response,
		selectedOption,
		otherResponse,
		survey,
		setCurrentQuestion,
		setSelectedOption,
		setResponse,
		setOtherResponse,
		setCompleted,
		saveSurvey,
	]);

	return { isDisabled, handleContinue };
};
